<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">咨询管理</el-breadcrumb-item>
      <el-breadcrumb-item>咨询管理日志</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">


          <el-form-item label="公司名称" prop="companyName">
            <el-input size="small" style="width: 200px;" v-model="formInline.companyName" placeholder="公司名称"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input size="small" style="width: 200px;" v-model="formInline.userName" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input size="small" style="width: 200px;" v-model="formInline.phone" placeholder="手机号"></el-input>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList(1)" >搜索</el-button>
            <el-button size="small" type="danger" @click="handlePlDel" >批量删除</el-button>
            <el-button size="small" type="primary" icon="el-icon-download" @click="importExcelItem()">导出数据</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }"  @selection-change="handleSelectionChangeDel">


          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="openId" label="用户ID" align="center"></el-table-column>
          <el-table-column prop="nickName" label="用户昵称" align="center"></el-table-column>
          <el-table-column prop="avatar" label="用户头像" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.avatar != null && scope.row.avatar != ''">
                <el-popover placement="top-start" trigger="hover">
                  <a :href="scope.row.avatar" target="_blank" title="查看最大化图片"><img :src="scope.row.avatar" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.avatar" style="width: 100px;height: 100px; cursor:pointer" />
                </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
          <el-table-column prop="userName" label="用户名称" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="remark" label="咨询描述" align="center"></el-table-column>
          <el-table-column align="center"  prop="createTime" label="时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="deleteData(scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
              <el-button size="mini" v-if="scope.row.status == 0" type="primary" @click="clData(scope.row)"style="width: 100px;margin: 1px;">已处理</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>







      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryConsultInfo, delConsultInfo, delConsultInfoPl, downloadConsultInfo,upConsultInfo} from '../../api/couApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";

export default {
  name: "userList",

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        userName:'',
        companyName:'',
        phone:'',
        page:1,
        pageSize:10
      },
      listData:[],
      multipleSelection:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryConsultInfo(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    resetFrom(){
      this.formInline.userName = '';
      this.formInline.phone = '';
      this.formInline.companyName = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },




    deleteData(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delConsultInfo(row)
                .then(res => {
                  if (res.code==1) {
                    this.$message({
                      type: 'success',
                      message: '数据已更新!'
                    })
                    this.tableList(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.$message.error('数据删除失败，请稍后再试！')
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
    },


    clData(row) {
      this.$confirm('确定要修改为已处理吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            var data = {
              id:row.id,
              status:1
            }
            upConsultInfo(data)
                .then(res => {
                  if (res.code==1) {
                    this.$message({
                      type: 'success',
                      message: '数据已更新!'
                    })
                    this.tableList(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.$message.error('数据更新失败，请稍后再试！')
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消！'
            })
          })
    },




    handleSelectionChangeDel(val){
      this.multipleSelection = val;
    },

    handlePlDel() {
      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }
      this.isDisabled = true;
      var data = {
        ids:this.multipleSelection.map(element=>element.id)
      }
      this.$refs.tabs.clearSelection();
      delConsultInfoPl(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList();
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },

    importExcelItem(){
      downloadConsultInfo(this.formInline).then(res=>{
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        // type值看后台格式,有可能是application/x-xls或application/vnd.ms-excel
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = timestampToTime(new Date())+'导出咨询管理日志.xls'
        link.click()
      });
    },


  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/zx/log.vue